import { SelectedServiceType } from "./../models/selected-service-type-list";
import { CloudCode } from "./cloudcode";
import { Util } from "./util";
import { Address } from "./../models/address";

export interface AvailData {
    dates: Date[],
    sortedTimeslots: BarberTimeslot[][],
    customAddress?: Address
}

export interface BarberTimeslot {
    id: string,
    date: Date,
    locked: boolean,
    unavailableInZip: boolean
    useCustomAddress: boolean
    address?: Address
}

export class BarberAvailService {
    static fetch(
        barberID: string,
        serviceTypeList: SelectedServiceType[], 
        address: Address, 
        barberProfileNavHistory: string,
        canBook: boolean,
        successCallback: (availData: AvailData) => void,
        errorCallback: (msg: string) => void
    ) {

        let params = {
            barberID: barberID,
            serviceTypeList: serviceTypeList,
            address: address,
            pull3Weeks: true,
            barberProfileNavHistory: barberProfileNavHistory,
            mainScreenGroupCanBook: canBook,
            includeOutOfRadiusAvails: true,
        }

        CloudCode.run('pullBarberAvailableTimeslots', params, 
        (rsp: any) => {
            if (rsp.apptTimes && rsp.apptTimes.length > 0) {
                let allTimeslots: BarberTimeslot[] = rsp.apptTimes;
                let compareDate = allTimeslots[0].date;
                let dates: Date[] = [compareDate];
                let sortedTimeslots: BarberTimeslot[][] = [];
                let timeslots: BarberTimeslot[] = [];
                let customAddress: Address;

                for (let timeslot of allTimeslots) {
                    let date = timeslot.date;
                    if (!Util.isSameDay(date, compareDate)) {
                        dates.push(date);
                        compareDate = date;
                        sortedTimeslots.push(timeslots);
                        timeslots = [timeslot];
                    } else {
                        timeslots.push(timeslot);
                    }

                    if (!customAddress) {
                        customAddress = timeslot.address
                    }
                }
                
                // if (timeslots.length) {
                    sortedTimeslots.push(timeslots);
                // }

                successCallback({ dates: dates, sortedTimeslots: sortedTimeslots, customAddress: customAddress });
            } else {
                errorCallback('No availabilities for this request. Please contact support to reschedule, or cancel and rebook.');
            }
        }, 
        (msg: string) => {
            errorCallback(msg);
        });
    }
}